export default __webpack_public_path__ + "static/media/processingGif.d71f097e.gif";